var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "product__section" }, [
    _c("h2", { staticClass: "product__section__heading" }, [
      _vm._v("\n    " + _vm._s(_vm.$modeoL10n.product_details) + "\n  ")
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "product__section__list" },
      [
        _vm.adjustments.length > 0
          ? _c("li", { staticClass: "product__section__list-item" }, [
              _c("span", { staticClass: "product__section__label" }, [
                _vm._v(_vm._s(_vm.$modeoL10n.adjustment_options))
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "product__section__adjustment-list" },
                _vm._l(_vm.adjustments, function(adjustment, index) {
                  return _c("li", { key: index }, [
                    _vm._v(
                      "\n          " + _vm._s(adjustment.label) + "\n        "
                    )
                  ])
                }),
                0
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.visibleDetails, function(detail, index) {
          return _c(
            "li",
            { key: index, staticClass: "product__section__list-item" },
            [
              _c("span", { staticClass: "product__section__label" }, [
                _vm._v(_vm._s(detail.label))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "product__section__value" }, [
                _vm._v(_vm._s(detail.value))
              ])
            ]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.otherDetails.length > 3
      ? _c(
          "button",
          {
            staticClass: "product__section__show-more show-more-button",
            class: { "show-more-button--close": _vm.showFullContent },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.toggle()
              }
            }
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.showFullContent
                    ? _vm.$modeoL10n.hide
                    : _vm.$modeoL10n.show_more
                ) +
                "\n  "
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-740527fc", { render: render, staticRenderFns: staticRenderFns })
  }
}